import merge from "deepmerge";
import { IMetadataFilter} from "@jorsek/content-portal-configs/types";

export const applyStructureMeta = (item)=> {
    return {...item, ...(item.meta || []).reduce((acc, m)=> {
            const key = m.name || m.id;
            acc[key] = m.value;
            return acc;
        }, {})}
}
const reduceMeta = (content, reducer, acc = {}):any=>{
    return Object.entries(merge.all([content.standardMetadata || {}, content.customMetadata || {}])).reduce((acc, [, metaVal])=>{
        Object.entries(metaVal).forEach(([key, val]:any)=> {
            acc = reducer(acc, key, val);
        });
        return acc;
    }, acc);
}
export const getContentMetadataArray = (content):any[] => {
    return reduceMeta(content,(acc, key, val)=>{
        acc.push({
            key,
            value: val.value || val
        })
        return acc;
    }, [])
}

export const getContentMetadataObj = (content):any => {
    return reduceMeta(content,(acc, key, val)=>{
       acc[key] = val.value || val;
       return acc;
    }, {});
}

export function addMeta(filter: IMetadataFilter, key: string): boolean {
    // If no includes or excludes are present, return true
    if (!filter) {
        return true;
    }

    if (!filter.include && !filter.exclude) {
        return true;
    }

    // If includes are present, return true only if key is in the list of includes
    if (filter.include && filter.include.length > 0) {
        return filter.include.includes(key);
    }

    // If excludes are present, return true only if key is NOT in the list of excludes
    if (filter.exclude && filter.exclude.length > 0) {
        return !filter.exclude.includes(key);
    }

    // Default case (should not reach here based on the conditions above)
    return true;
}